import { render, staticRenderFns } from "./DownloadUtil.vue?vue&type=template&id=fabf80e2&scoped=true"
import script from "./DownloadUtil.vue?vue&type=script&lang=js"
export * from "./DownloadUtil.vue?vue&type=script&lang=js"
import style0 from "./DownloadUtil.vue?vue&type=style&index=0&id=fabf80e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabf80e2",
  null
  
)

export default component.exports